import { UseFormReturn, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { LENGTH_XS } from '@/util/validation/constants';

import type { CampaignSetupForm } from '../types';

interface CampaignNameFieldProps {
  form: UseFormReturn<CampaignSetupForm>;
  canWrite: boolean;
  onNameChange: (value: string) => string;
}

export const CampaignNameField = ({ form, canWrite, onNameChange }: CampaignNameFieldProps) => {
  const { t } = useTranslation();
  const campaignName = useWatch({ control: form.control, name: 'name' });
  const characterCount = campaignName?.length || 0;

  return (
    <FormField
      control={form.control}
      name="name"
      render={({ field }) => (
        <FormItem>
          <div className="flex items-center justify-between">
            <FormLabel>{t('campaigns.setup.campaign_name')}</FormLabel>
            <span className="text-sm text-foreground">
              {characterCount}/{LENGTH_XS}
            </span>
          </div>
          <FormControl>
            <Input
              placeholder={t('campaigns.setup.campaign_name_placeholder')}
              maxLength={LENGTH_XS}
              autoFocus
              disabled={!canWrite}
              {...field}
              onChange={(e) => {
                const value = e.target.value;
                field.onChange(value);
                onNameChange(value);
                form.trigger('name');
              }}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
